<template>
  <div style="min-height: 92vh" class="pa-4">
    <div class="d-flex align-center mb-4">
      <h3 class="text-h5 font-weight-bold">Paquetes Bokka</h3>
      <v-spacer></v-spacer>
    </div>

    <uv-data-table :config="config" :data="paquetes" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>

    <modal v-model="showModal" :showFooter="false" :title="editMode ? 'Editar Paquete' : 'Nuevo Paquete'">
      <PaquetesForm :edit="editMode" :key="formKey" :dataEdit="editData" @toggle="showModal = false"
        @successData="successData" />
    </modal>
  </div>
</template>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import PaquetesForm from "./PaquetesForm.vue";

export default {
  name: "Paquetes",
  components: {
    modal,
    uvDataTable,
    PaquetesForm,
  },
  data() {
    return {
      showModal: false,
      editMode: false,
      editData: {},
      formKey: 0,
      // Mock data for demonstration, normally fetched from API/Store
      paquetes: [
        {
          id: 'plan_wine_club',
          title: 'Club del Sommelier',
          badge: 'PARA CONOCEDORES',
          isRecommended: false,
          pricing: {
            amount: 89.99,
            currency: 'USD',
            interval: '/mo'
          },
          priceBreakdown: 'Cargo mensual recurrente. Incluye descorche libre.',
          description:
            'Acceso exclusivo a nuestra reserva privada y eventos de cata para los amantes del buen vino.',
          marketingPitch:
            'Al unirte a este selecto club, aseguras la oportunidad de descubrir etiquetas de edición limitada antes que nadie. Recibirás atención personalizada de nuestro sommelier en cada visita, garantizando que cada copa eleve tu experiencia gastronómica a un nivel de absoluta sofisticación.',
          features: [
            '2 botellas de vino reserva al mes',
            'Maridaje en cortesía para ti y un acompañante',
            'Descorche libre todos los días',
            'Invitación a catas privadas bimensuales'
          ],
          buttonText: 'Unirme al Club',
          availableCount: 5
        }
      ],
      config: {
        selectableRow: true,
        orderByCol: { Field: "Nombre", Type: "Asc" },
        allowExport: true,
        rawText: "Eventos",
        selectConfig: {
          idRowData: "Id",
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addEvento",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editEvento",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteEvento",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre de Evento",
            value: "nm",
          },
          {
            text: "Tipo de Recurrencia",
            value: "Tipo",
            format: (row) => {
              return row.Tipo === "F" ? "Fecha Fija" : "Se repite";
            }
          },
          {
            text: "Detalle Recurrencia",
            value: "Recurrencia",
            format: (row) => {
              return row.Tipo === "F" ? row.vr[0] : row.vr;
            }
          },
          {
            text: "Descripción",
            value: "ds",
          }
        ],
      },
    };
  },
  methods: {
    async getEventos() {
      /*const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("MKT_Eventos", [
          firestore.where(
              "tn",
              "==",
              this.$store.getters.getFirebaseApp.tenant
          ),
          firestore.where(
              "da",
              "==",
              null
          ),
      ]);
      if (data.empty) {
          this.eventos = [];

      } else {
          let doc = data.docs.map((doc) => {
              return { Id: doc.ref.id, ...doc.data() };
          });
          this.eventos = doc;
      }*/
      //this.paquetes = []

    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId === "addEvento") {
        this.editMode = false;
        this.editData = {};
        this.formKey++;
        this.showModal = true;
      } else if (buttonId === "editEvento") {
        console.log(idSelected)
        this.editMode = true;
        this.editData = this.paquetes.find(e => e.Id === idSelected[0]);
        this.formKey++;
        this.showModal = true;
      } else if (buttonId === "deleteEvento") {
        console.log(idSelected)
        this.deleteEvento(idSelected[0]);
      }
    },
    successData(data, mode) {
      const formData = new FormData();
      formData.append("id", data.id);
      formData.append("nm", data.nm);
      formData.append("ds", data.ds);
      formData.append("tr", data.tr);
      formData.append("at", data.at);
      data.vr.forEach((value) => {
        formData.append('vr[]', value);
      });
      data.ag.forEach((value) => {
        formData.append('ag[]', value);
      });
      formData.append("tenant", this.$store.getters.getFirebaseApp.tenant);
      formData.append("tn", this.$store.getters.getFirebaseApp.tenant);
      if (data.Multimedia) {
        formData.append("Multimedia", data.Multimedia, "Multimedia.jpg");
      }

      if (mode === "CREATE") {
        this.$alert.alertConfirmFormData({
          action: "crear",
          obj: "el evento",
          route: "MKT-Eventos-crearEvento",
          data: formData,
          onSuccess: () => {
            this.getEventos();
            this.showModal = false;
          },
        });
      } else {
        this.$alert.alertConfirmFormData({
          action: "actualizar",
          obj: "el evento",
          route: "MKT-Eventos-actualizarEvento",
          data: formData,
          onSuccess: () => {
            this.getEventos()
            this.showModal = false;
          },
        });
      }

    },
    deleteEvento(id) {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("Id", id);
      formData.append("tenant", this.$store.getters.getFirebaseApp.tenant);
      this.$alert.alertConfirmFormData({
        action: "eliminar",
        route: "MKT-Eventos-eliminarEvento",
        data: formData,
        obj: "el evento",
        onSuccess: () => {
          this.getEventos()
        },
      });
    }
  },
  mounted() {
    this.getEventos();
  }
};
</script>

<style scoped>
.text-h5 {
  color: #333;
}
</style>
